import { render } from "./PayrollModal.vue?vue&type=template&id=4ff1dc9e&scoped=true"
import script from "./PayrollModal.vue?vue&type=script&lang=js"
export * from "./PayrollModal.vue?vue&type=script&lang=js"

import "./PayrollModal.vue?vue&type=style&index=0&id=4ff1dc9e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff1dc9e"]])

export default __exports__